import { render, staticRenderFns } from "./chainBasicInfo.vue?vue&type=template&id=4f47a780&scoped=true&"
import script from "./chainBasicInfo.vue?vue&type=script&lang=js&"
export * from "./chainBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./chainBasicInfo.vue?vue&type=style&index=0&id=4f47a780&scoped=true&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f47a780",
  null
  
)

export default component.exports